import React, { useMemo } from 'react';
import { PortableText } from '@portabletext/react';

import { RichTextProps } from './types';
import * as Styled from './styles';
import { components } from './consts';

const RichText: React.FC<RichTextProps> = ({
  data,
  elementsMargin = '1.5rem',
  hasDarkBackground,
  textAlign,
}) => {
  // For now, let's use a simple working solution
  const simpleWorkingComponents = useMemo(() => ({
    types: {
      block: ({ children, value }: any) => {
        const style = value?.style || 'normal';
        
        // Map Sanity styles to appropriate HTML elements
        const styleMap: Record<string, any> = {
          'headingXL': { tag: 'h1', fontSize: '2rem', fontWeight: 'bold' },
          'headingL': { tag: 'h2', fontSize: '1.5rem', fontWeight: 'bold' },
          'headingM': { tag: 'h3', fontSize: '1.25rem', fontWeight: 'bold' },
          'normal': { tag: 'p', fontSize: '1rem', fontWeight: 'normal' }
        };
        
        const config = styleMap[style] || styleMap.normal;
        const Tag = config.tag;
        
        return (
          <Tag style={{
            fontSize: config.fontSize,
            fontWeight: config.fontWeight,
            margin: '1em 0',
            lineHeight: '1.6',
            textAlign: textAlign as any
          }}>
            {children}
          </Tag>
        );
      },
    },
    marks: {
      strong: ({ children }: any) => <strong>{children}</strong>,
      em: ({ children }: any) => <em>{children}</em>,
    },
  }), [textAlign]);

  if (!data) {
    return <Styled.RichTextContainer {...{ elementsMargin, hasDarkBackground }} />;
  }

  return (
    <Styled.RichTextContainer {...{ elementsMargin, hasDarkBackground }}>
      {/* Use PortableText without custom components - we know this works */}
      <PortableText value={data} />
    </Styled.RichTextContainer>
  );
};

export default RichText;
